import { QrcodeOutlined } from '@ant-design/icons';

import { Html5QrcodeScannerState } from 'html5-qrcode';

import styles from './styles.module.css';
import { Attendance } from '../../types';

type EmptyStateProps = {
  scannerState: Html5QrcodeScannerState | null;
  attendance: Attendance | null;
  loading: boolean;
  errorMessage: string | null;
};

const EmptyState = ({ scannerState, attendance, loading, errorMessage }: EmptyStateProps) => {
  if (errorMessage) {
    return null;
  }

  if (!scannerState || attendance) {
    return null;
  }

  if (scannerState === Html5QrcodeScannerState.SCANNING && loading) {
    return null;
  }

  return (
    <div className={styles.container}>
      <QrcodeOutlined className={styles.icon} />
      <p>Aponte a câmera do seu celular para o QR Code do ingresso para escaneá-lo.</p>
    </div>
  );
};

export default EmptyState;
